module.exports = __webpack_public_path__ + "img/ring_skip_0_1_null@3x.41aa22ac.png";